import { render, staticRenderFns } from "./goodsClose.vue?vue&type=template&id=18379fe2&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./goodsClose.vue?vue&type=script&lang=js"
export * from "./goodsClose.vue?vue&type=script&lang=js"
import style0 from "./goodsClose.vue?vue&type=style&index=0&id=18379fe2&prod&lang=scss&scoped=true"
import style1 from "./goodsClose.vue?vue&type=style&index=1&id=18379fe2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18379fe2",
  null
  
)

export default component.exports